import { Box, Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { GenericFunction } from "../../../types/generic.types";

const LocalizedRichText: FC<ContactUsProps> = ({ onChange, hasError, initialValue }) => {
  const [value, setValue] = useState<IValue>({ en: "", ar: "" });

  const regexp = /^(<[^>]*>)(<\/?br>|\s*)(<\/[^>]*>)$/i;

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "direction",
    "link",
  ];

  const isValid = (text: any): boolean => {
    return !!text && text.trim().length > 0 && text.match(regexp) === null;
  };

  useEffect(() => {
    onChange(value);
    hasError(!isValid(value?.en) || !isValid(value?.ar));
  }, [value]);

  useEffect(() => {
    if (initialValue) setValue(initialValue);
  }, [initialValue]);

  return (
    <>
      <Box mb={1}>
        <Typography color="textSecondary">English</Typography>
        <ReactQuill
          value={value?.en ?? ""}
          onChange={(value) => {
            setValue((prevState) => ({
              ...prevState,
              en: value,
            }));
          }}
          style={{
            borderRadius: 5,
          }}
          modules={modules}
          formats={formats}
        />
      </Box>
      <Box mb={1}>
        <Typography color="textSecondary">Arabic</Typography>
        <ReactQuill
          value={value?.ar ?? ""}
          onChange={(value) => {
            setValue((prevState) => ({
              ...prevState,
              ar: value,
            }));
          }}
          style={{
            borderRadius: 5,
          }}
          modules={modules}
          formats={formats}
        />
      </Box>
    </>
  );
};

interface IValue {
  en: string;
  ar: string;
}

interface ContactUsProps {
  onChange: GenericFunction;
  hasError: GenericFunction;
  initialValue: IValue | undefined;
}

export default LocalizedRichText;
